import { Controller } from '@hotwired/stimulus';

export default class SmartInvestAnnouncementController extends Controller {
  static targets = ['modal'];

  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget);

    if (this.mustDisplay()) {
      this.modal.show();
      sessionStorage.setItem('smartInvestAknowledge', 'true');
    }
  }

  acknowledge(event) {
    const { checked } = event.target;

    localStorage.setItem('smartInvestAknowledge', checked?.toString());
  }

  mustDisplay() {
    return sessionStorage.getItem('smartInvestAknowledge') != 'true'
      && localStorage.getItem('smartInvestAknowledge') != 'true'
  }
}
